var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6552(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 490,
    height: 512.001,
    viewBox: "0 0 490 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6552",
    "data-name": "Group 6552",
    transform: "translate(-11 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M475.955,375A243.988,243.988,0,0,0,501,267C501,131.69,391.31,22,256,22S11,131.69,11,267A243.988,243.988,0,0,0,36.045,375Z",
    fill: "#f5d930"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M181.139,250.064H201.92v15.244H181.139Z",
    fill: "#0f3e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M310.1,250.064h20.781v15.244H310.1Z",
    fill: "#0f3e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M184.457,263.766c-10.946,16.523-6.7,36.726-1.134,50.866,19.444,49.4,71.833,67.94,72.36,68.122l.326.112.326-.112c.527-.182,52.917-18.722,72.361-68.122,5.564-14.136,9.81-34.334-1.128-50.855l-.164-.072a56.716,56.716,0,0,0-22.732-4.755H207.33A56.715,56.715,0,0,0,184.6,263.7Z",
    fill: "#ebf0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M184.6,263.7l-.14.061c-10.947,16.523-6.7,36.726-1.135,50.866,19.444,49.4,71.833,67.94,72.361,68.122l.326.112.326-.112c.025-.009.176-.062.436-.159-.254-.262-.5-.524-.762-.787-35.707-35.707-11.6-68.535-11.6-68.535l-24.581-54.324h-12.5a56.73,56.73,0,0,0-22.732,4.756Z",
    fill: "#c2d4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M452.111,324.153a47.221,47.221,0,0,0-23.98-20.907L399.9,292.183c3.043,12.015-3.18,26.8-18.517,43.96-22.294,24.941-55.176,37.523-78.834,43.686a240.56,240.56,0,0,1-46.506,7.48,239.9,239.9,0,0,1-46.53-7.469c-23.673-6.162-56.574-18.745-78.878-43.7-15.34-17.162-21.563-31.951-18.516-43.968L83.871,303.245a47.225,47.225,0,0,0-23.98,20.907c-7.869,14.055-16.3,31.734-24.343,49.848A245.992,245.992,0,0,0,152.023,488.893V463.884a10.946,10.946,0,0,1,10.914-10.914h186.8a10.946,10.946,0,0,1,10.914,10.914v24.692A246.007,246.007,0,0,0,476.451,374c-8.042-18.113-16.473-35.792-24.34-49.846Z",
    fill: "#2c2c42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M130.645,342.231a8.247,8.247,0,0,0,3.142-2.73c-1.069-1.1-2.126-2.21-3.152-3.358-15.34-17.162-21.563-31.951-18.516-43.968L83.87,303.246a47.225,47.225,0,0,0-23.98,20.907c-7.868,14.054-16.3,31.733-24.342,49.847a245.652,245.652,0,0,0,49.867,68.824c4.13-18.044,10.482-45.573,14.87-63.543,5.532-22.654,23.194-33.5,30.36-37.05Z",
    fill: "#212135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M256,512a244,244,0,0,0,105.652-23.892V461.884a10.946,10.946,0,0,0-10.914-10.914h-188.8a10.946,10.946,0,0,0-10.914,10.914v26.54A244,244,0,0,0,256,512Z",
    fill: "#fbcc68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M238.716,475.47a25.6,25.6,0,0,1,18.469-24.5H161.938a10.946,10.946,0,0,0-10.914,10.914v26.54a243.552,243.552,0,0,0,87.693,22.95v-35.9Z",
    fill: "#efaa42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M340.483,268.9l-11.625-4.556L327.4,263.7a56.716,56.716,0,0,0-22.732-4.755H207.329A56.715,56.715,0,0,0,184.6,263.7l-1.455.637L171.517,268.9a87.1,87.1,0,0,0,168.966,0Z",
    fill: "#c2d4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M190.679,262.363c.648-.158,1.3-.319,1.949-.47q.619-.621,1.228-1.3A56.684,56.684,0,0,0,184.6,263.7l-1.455.637L171.517,268.9a87.2,87.2,0,0,0,65.5,63.825,47.852,47.852,0,0,1,7.39-19.449l-.991-2.19A67.784,67.784,0,0,1,190.679,262.363Z",
    fill: "#99b8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M322,261.663a56.723,56.723,0,0,0-17.327-2.713H207.329A56.723,56.723,0,0,0,190,261.663a67.7,67.7,0,0,0,132,0Z",
    fill: "#e0d3cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M304.039,233.818c-8.422,11.921-19.716,23.061-34.779,30.347a30.413,30.413,0,0,1-13.149,3.085h-.176a30.467,30.467,0,0,1-13.2-3.108c-15.057-7.294-26.344-18.441-34.761-30.366-3.027,11.208-8.643,23.416-15.345,30.117-.653.151-1.3.311-1.949.47a67.7,67.7,0,0,0,130.641,0c-.648-.158-1.3-.319-1.949-.47-6.691-6.692-12.3-18.879-15.331-30.075Z",
    fill: "#ffaa7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M258.163,267.164c-.682.05-1.366.084-2.052.085h-.176a30.467,30.467,0,0,1-13.2-3.108c-15.057-7.294-26.344-18.441-34.761-30.366-3.026,11.208-8.643,23.416-15.345,30.117-.653.151-1.3.311-1.949.47a67.785,67.785,0,0,0,53.73,48.91C252.849,298.483,256.576,281.223,258.163,267.164Z",
    fill: "#f7996b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M345.146,137.59c-3.685-3.377-11.024-1.665-14.2.4a44.589,44.589,0,0,1,.134,13.132L326.34,178.4c0,2.2-.26,4.356-.388,6.475,9.132,2.754,14.856-5.444,15.62-11.07a41.863,41.863,0,0,1,1.613-7.138C345.615,159.081,354.378,146.051,345.146,137.59Z",
    fill: "#ffaa7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M166.873,137.59c3.685-3.377,11.025-1.665,14.2.4a44.589,44.589,0,0,0-.134,13.132l4.742,27.275c0,2.2.505,4.356.632,6.475-9.132,2.754-15.1-5.444-15.865-11.07a41.861,41.861,0,0,0-1.613-7.138c-2.429-7.586-11.192-20.616-1.96-29.077Z",
    fill: "#f7996b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M328.694,129.566a36.388,36.388,0,0,0-3.244-6.527,19.6,19.6,0,0,1-2.961-11.962c.874-12.068.4-35.671-15.437-42.8-13.46-6.057-29.971-2.55-40.5.952a33.434,33.434,0,0,1-21.084,0c-10.529-3.5-27.04-7.008-40.5-.952-15.888,7.149-16.314,30.867-15.43,42.9a19.415,19.415,0,0,1-2.969,11.86,35.981,35.981,0,0,0-3.054,6.04,44.081,44.081,0,0,0-2.547,22.274l3.714,27.047s9.248,64.1,58.052,87.742a30.467,30.467,0,0,0,13.2,3.108h.176a30.413,30.413,0,0,0,13.149-3.085c47.528-22.989,57.569-84.326,58.076-87.615,0-.05,0-.1,0-.149l3.745-27.275a43.657,43.657,0,0,0-2.39-21.561Z",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M237.93,178.4l-2.367-27.047a67.7,67.7,0,0,1,1.623-22.274,46.553,46.553,0,0,1,1.946-6.04,28.449,28.449,0,0,0,1.892-11.86c-.522-11.151-.321-32.317,7.761-41.057a33.328,33.328,0,0,1-3.319-.894c-10.529-3.5-27.039-7.008-40.5-.952-15.888,7.149-16.314,30.867-15.43,42.9a19.415,19.415,0,0,1-2.969,11.86,35.981,35.981,0,0,0-3.054,6.04,44.07,44.07,0,0,0-2.547,22.274l3.714,27.047s9.248,64.1,58.052,87.742a30.467,30.467,0,0,0,13.2,3.108h.175a30.413,30.413,0,0,0,13.149-3.085c1.186-.574,2.341-1.177,3.481-1.8-29.19-24.912-34.81-85.968-34.81-85.968Z",
    fill: "#ffaa7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6551",
    "data-name": "Group 6551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M357.1,84.053c4.637-.706,9.742-4.356,12.55-6.635a1.767,1.767,0,0,0-.367-2.964c-21.943-10.737-35.126-45.543-52.964-56.591-15.267-9.456-28.432-4.01-32.576-1.812a1.753,1.753,0,0,1-2.241-.524C275.609,7.312,265.826,2.437,260.079.133A1.772,1.772,0,0,0,257.848,2.6a39.184,39.184,0,0,1,4.054,11.42,1.766,1.766,0,0,1-2.524,1.873c-19.243-9.511-53.461-2.74-74.35,22.8-17.38,21.251-30.772,24.437-35.6,24.842a1.764,1.764,0,0,0-1.559,2.208c1.871,7.066,9.088,11.643,12.143,13.3a1.739,1.739,0,0,1,.718,2.373c-1.45,2.5-4.549,4.011-6.368,4.72a1.753,1.753,0,0,0-1.071,2.024c1.755,7.813,10.035,43.237,18.8,56.97,6.111,9.574,9.452,22.507,11.113,30.981a1.048,1.048,0,0,0,2.075-.128c.652-9.245,1.6-24.316,1.967-38.437.453-17.324,15.587-27.5,22.483-31.254a1.771,1.771,0,0,1,2.568,1.944l-.942,4.267a1.775,1.775,0,0,0,2.02,2.133C265.068,105.992,284.05,88.132,290.981,77a1.988,1.988,0,0,1,2.3-.844,2.009,2.009,0,0,1,1.381,1.825C296.279,111.242,322,115.3,325.705,130.05c3.044,12.106,2.269,35.075,1.683,45.913a1.363,1.363,0,0,0,2.586.67c8.063-17.056,6.9-40.638,19.718-56.224,10.411-12.664,15.255-20.972,17.1-24.5a1.755,1.755,0,0,0-1.055-2.478,21.739,21.739,0,0,1-9.715-6.484,1.764,1.764,0,0,1,1.081-2.892Z",
    fill: "#404051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M374.375,268.267a13.529,13.529,0,0,1-7.027-5.465c-5.727-8.883-22.785-27.978-57.249-12.738,0,0,37.167,14.658,17.667,64.2s-71.756,67.543-71.756,67.543v6.5s82.62-2.833,126.12-51.5c41.6-46.536,5.877-63.914-7.755-68.541Z",
    fill: "#404051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M137.643,268.267a13.529,13.529,0,0,0,7.027-5.465c5.728-8.883,22.785-27.978,57.25-12.738,0,0-37.167,14.658-17.667,64.2s71.756,67.543,71.756,67.543v6.5s-82.62-2.833-126.12-51.5c-41.6-46.536-5.878-63.914,7.754-68.541Z",
    fill: "#404051"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M133.167,340.3a7.919,7.919,0,0,0,1.5-2.478c6.108-16.363,20.38-7.976,27.95-21.493,8-14.284,19.11-9.3,19.11-9.3-13.311-43.748,20.192-56.967,20.192-56.967-34.465-15.24-51.522,3.855-57.25,12.738a13.529,13.529,0,0,1-7.027,5.465c-13.632,4.626-49.35,22.005-7.754,68.541C130.957,338,132.054,339.161,133.167,340.3Z",
    fill: "#2c2c42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M376.652,416.639v63.637q7.677-4.353,15-9.236v-54.4a7.5,7.5,0,0,0-15,0Z",
    fill: "#212135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M136.023,416.639a7.5,7.5,0,0,0-15,0V471.49q7.32,4.842,15,9.162Z",
    fill: "#212135"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(316.512 342.417)",
    fill: "#2c2c42"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 13.759,
    cy: 13.759,
    r: 13.759,
    transform: "translate(167.969 342.417)",
    fill: "#2c2c42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M330.271,351.783a7.5,7.5,0,0,0-7.5,7.5V468.975a7.5,7.5,0,0,0,15,0V359.283a7.5,7.5,0,0,0-7.5-7.5Z",
    fill: "#545460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M330.271,446.435a10.3,10.3,0,0,0-10.3,10.3v16.234a10.3,10.3,0,0,0,20.6,0V456.735A10.3,10.3,0,0,0,330.271,446.435Z",
    fill: "#ebf0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M181.728,351.783a7.5,7.5,0,0,0-7.5,7.5V468.975a7.5,7.5,0,0,0,15,0V359.283a7.5,7.5,0,0,0-7.5-7.5Z",
    fill: "#545460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M181.728,446.435a10.3,10.3,0,0,0-10.3,10.3v16.234a10.3,10.3,0,0,0,20.6,0V456.735A10.3,10.3,0,0,0,181.728,446.435Z",
    fill: "#ebf0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M330.271,467.268a10.3,10.3,0,0,1-10.3-10.3v16a10.3,10.3,0,0,0,20.6,0v-16A10.3,10.3,0,0,1,330.271,467.268Z",
    fill: "#c2d4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M181.728,467.268a10.3,10.3,0,0,1-10.3-10.3v16a10.3,10.3,0,0,0,20.6,0v-16A10.3,10.3,0,0,1,181.728,467.268Z",
    fill: "#c2d4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M241.118,48.947C215.684,28.665,259.378,15.9,259.378,15.9c-19.243-9.511-53.461-2.74-74.35,22.8-17.38,21.251-30.772,24.437-35.6,24.842a1.764,1.764,0,0,0-1.559,2.208c1.871,7.066,9.088,11.643,12.143,13.3a1.739,1.739,0,0,1,.718,2.373c-1.45,2.5-4.549,4.011-6.368,4.72a1.753,1.753,0,0,0-1.071,2.024c1.755,7.813,10.035,43.237,18.8,56.97,6.111,9.574,9.452,22.507,11.113,30.981a1.048,1.048,0,0,0,2.075-.128c.652-9.245,1.6-24.316,1.966-38.437.453-17.324,15.587-27.5,22.483-31.254a1.771,1.771,0,0,1,2.568,1.944l-.942,4.267a1.775,1.775,0,0,0,2.021,2.133,227.654,227.654,0,0,0,27.54-6.262c-11.018-27.716,25.633-39.153.2-59.433Z",
    fill: "#2c2c42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6552);
export default __webpack_public_path__ + "static/media/Group 6552.ca795ddaada9effb02ed8cf82b5a7836.svg";
export { ForwardRef as ReactComponent };